// import Vue from 'vue'
// import consts from "@/consts"
// import range from "lodash/range";
import {getApiProps, updateObjectByDiff} from "@/lib/lib";
// import {arraySplitIntoChunks} from "@/lib/lib";

const with_removed = String(process.env.VUE_APP_PACKAGE).includes('admin') ? {'force[with_removed]': 1} : {}
// const changedField = 'changed__time';

const collator = new Intl.Collator();
const sortByName = function (a, b) {
    let cmp = collator.compare(a?.name_ || '', b?.name_ || '')
    if (cmp) {
        return cmp;
    }
    return a?.fromDateTime?.utc - b.a?.fromDateTime?.utc;
}

// Built on every call and never cached: the array is also changed in place (splice on delete,
// push on a single update, sort in a getter) and nothing tells a cached map that it has gone stale.
function getShipmentsAlertsIndexMap(state) {
    return new Map(state.shipmentsAlerts.map((u, i) => [u.xid, i]))
}

export default {
    state: {
        shipmentsAlerts_index: [],
        shipmentsAlerts: [],
    },
    actions: {
        fetchShipmentAlerts/*all*/({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.shipmentId) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchShipmentAlerts', args, time: Date.now() / 1000})

                const params = getApiProps('shipmentsAlerts', args)
                this.$api.shipmentsAlerts.shipmentAlerts(args.shipmentId, {...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            commit('updateShipmentsAlerts', response.data)
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchShipmentAlerts', args, inprogress: false})
                    });
            })
        },


    },
    mutations: {
        setShipmentsAlerts(state, nShipmentsAlerts) {
            nShipmentsAlerts = nShipmentsAlerts.map(u => {
                if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                return u //Object.freeze(u)
            })
            nShipmentsAlerts.sort(sortByName)
            state.shipmentsAlerts = nShipmentsAlerts
        },

        updateShipmentsAlerts(state, nShipmentsAlerts) {
            if (!state.shipmentsAlerts.length) {
                nShipmentsAlerts = nShipmentsAlerts.map(u => {
                    if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                    return u //Object.freeze(u)
                })
                nShipmentsAlerts.sort(sortByName)
                state.shipmentsAlerts = nShipmentsAlerts
                // const chunks = arraySplitIntoChunks(nShipmentsAlerts)//.reverse();
                // const pushOnRenderTask = () => {
                //     if (chunks.length === 0) return;
                //     let chunk = chunks.pop();
                //     state.shipmentsAlerts.push(...chunk);
                //     setTimeout(() => {
                //     requestAnimationFrame(pushOnRenderTask);
                //     }, 300)
                //     //this.$nextTick().then(() => pushOnRenderTask())
                // }
                // pushOnRenderTask();
                return true
            }

            const indexByXid = getShipmentsAlertsIndexMap(state)
            nShipmentsAlerts.forEach(function (nShipmentAlert) {
                if (nShipmentAlert?.name) nShipmentAlert.name_ = nShipmentAlert.name.toLocaleLowerCase()
                let i = indexByXid.has(nShipmentAlert.xid) ? indexByXid.get(nShipmentAlert.xid) : -1
                if (i < 0) {
                    indexByXid.set(nShipmentAlert.xid, state.shipmentsAlerts.length)
                    state.shipmentsAlerts.push(nShipmentAlert) //(Object.freeze(nShipmentAlert))
                } else {
                    // if (!state.shipmentsAlertsFullLoad || state.shipmentsAlerts[i][changedField] != nShipmentAlert[changedField]) {
                    updateObjectByDiff(state.shipmentsAlerts[i], nShipmentAlert)
                    // delete nShipmentAlert.xid
                    // nShipmentAlert = {...state.shipmentsAlerts[i], ...nShipmentAlert}
                    // state.shipmentsAlerts[i] = nShipmentAlert //Object.freeze(nShipmentAlert)
                }
            })

        },
        filterShipmentsAlerts(state, nShipmentsAlerts) {
            // let Ids = state.shipmentsAlerts.map(u=> u.xid)
            let nIds = new Set(nShipmentsAlerts.map(u => u.xid))
            state.shipmentsAlerts = state.shipmentsAlerts.filter(u => nIds.has(u.xid))
        },
        updateShipmentAlert(state, nShipmentAlert) {
            if (nShipmentAlert?.name) nShipmentAlert.name_ = nShipmentAlert.name.toLocaleLowerCase()
            let i = state.shipmentsAlerts.findIndex(u => (u.xid == nShipmentAlert.xid))
            if (i < 0) {
                state.shipmentsAlerts.push(nShipmentAlert) //(Object.freeze(nShipmentAlert))
            } else {
                // if (state.shipmentsAlertsFullLoad || state.shipmentsAlerts[i][changedField] != nShipmentAlert[changedField]) {
                updateObjectByDiff(state.shipmentsAlerts[i], nShipmentAlert)
                // delete nShipmentAlert.xid
                // nShipmentAlert = {...state.shipmentsAlerts[i], ...nShipmentAlert}
                // state.shipmentsAlerts[i] = nShipmentAlert //Object.freeze(nShipmentAlert)
            }
        },

        clearShipmentsAlerts(state, {unitId} = {}) {
            if (unitId) {
                state.shipmentsAlerts = state.shipmentsAlerts.filter(a => (a.unit_id || a.object_id) != unitId)
                state.shipmentsAlerts_index = state.shipmentsAlerts_index.filter(i => i.unitId != unitId)
            } else {
                state.shipmentsAlerts = []
                state.shipmentsAlerts_index = []
            }
        },
    },
    getters: {
        getShipmentsAlerts(state) {
            return state.shipmentsAlerts
        },
    }
}
